import { useEffect, useState } from "react";
import { api, day } from "./api.js";

// Адмінка (#/admin/<розділ>, server/src/modules/admin.js): користувачі — активація й продовження на місяць чи рік,
// деактивація, блокування, права
// адміністратора; токени активації — створити (показується один раз) і відкликати
const TABS = [["users", "Користувачі"], ["tokens", "Токени активації"]];
const STATES = [["all", "Усі"], ["pending", "Чекають активації"], ["active", "Активні"], ["disabled", "Заблоковані"]];
const MONTHS = [[1, "1 місяць"], [12, "рік"]];
const when = (iso) => (iso ? new Date(iso).toLocaleString("uk-UA", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export default function Admin({ user, tab = "users" }) {
  const cur = TABS.some(([k]) => k === tab) ? tab : "users";
  return (
    <section className="account admin">
      <div className="section-head"><div><h1>Адмінка</h1><p className="muted">Користувачі сервісу й токени активації</p></div></div>
      <div className="tabs reports-tabs" role="tablist" aria-label="Адмінка">
        {TABS.map(([k, l]) => <a key={k} role="tab" aria-selected={cur === k} className={`tab${cur === k ? " active" : ""}`} href={`#/admin/${k}`}>{l}</a>)}
      </div>
      {cur === "users" ? <Users me={user} /> : <Tokens />}
    </section>
  );
}

function Users({ me }) {
  const [q, setQ] = useState(""), [state, setState] = useState("all"), [d, setD] = useState(null), [err, setErr] = useState(""), [v, setV] = useState(0);
  const [months, setMonths] = useState({}), [busy, setBusy] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api(`/api/admin/users?state=${state}&q=${encodeURIComponent(q.trim())}`).then(setD, (e) => setErr(e.message)), q ? 250 : 0);
    return () => clearTimeout(t);
  }, [q, state, v]);
  const act = async (id, path, body, confirmText) => {
    if (confirmText && !confirm(confirmText)) return;
    setBusy(`${id}${path}`); setErr("");
    try { await api(`/api/admin/users/${id}/${path}`, { method: "POST", body }); setV((x) => x + 1); }
    catch (x) { setErr(x.message); } finally { setBusy(""); }
  };
  return (
    <div className="card">
      <div className="admin-filters">
        <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Пошук: email або ім'я" aria-label="Пошук користувачів" />
        <div className="seg" role="group" aria-label="Стан">
          {STATES.map(([k, l]) => <button key={k} type="button" aria-pressed={state === k} className={state === k ? "on" : ""} onClick={() => setState(k)}>
            {l}{d?.counts ? <span className="count">{d.counts[k]}</span> : null}</button>)}
        </div>
      </div>
      {err && <p className="error small" role="alert">{err}</p>}
      {!d ? <p className="muted" role="status">Завантаження…</p> : !d.users.length ? <p className="empty">Нікого не знайдено.</p> : (
        <div className="table-wrap" tabIndex={0} role="region" aria-label="Користувачі">
          <table className="table-static admin-table">
            <thead><tr><th>Користувач</th><th>Стан</th><th className="num">Компаній</th><th>Зареєстровано / вхід</th><th>Дії</th></tr></thead>
            <tbody>{d.users.map((u) => (
              <tr key={u.id}>
                <td><b>{u.email}</b>{u.name && <><br /><span className="muted small">{u.name}</span></>}
                  {u.isAdmin && <span className="badge badge-info admin-tag">адмін{u.adminByConfig ? " · ADMIN_EMAILS" : ""}</span>}</td>
                <td>{u.disabled ? <span className="badge badge-bad">Заблоковано</span>
                  : u.active ? <span className="badge badge-ok">{u.activatedUntil ? `Активний до ${day(u.activatedUntil)}` : "Активний, без строку"}</span>
                  : u.activatedUntil ? <span className="badge badge-bad">Строк минув {day(u.activatedUntil)}</span> : <span className="badge badge-warn">Чекає активації</span>}
                  {u.prepaidMonths > 0 && <><br /><span className="muted small">оплачено наперед: {u.prepaidMonths} міс.</span></>}</td>
                <td className="num">{u.companies}</td>
                <td className="small">{when(u.createdAt)}<br /><span className="muted">вхід: {when(u.lastLoginAt)}</span></td>
                <td className="admin-acts">
                  {!u.disabled && !u.adminByConfig && <>
                    <select aria-label={`Строк доступу для ${u.email}`} value={months[u.id] ?? 1} onChange={(e) => setMonths({ ...months, [u.id]: Number(e.target.value) })}>
                      {MONTHS.map(([m, l]) => <option key={m} value={m}>{l}</option>)}</select>
                    <button type="button" className={u.active ? "btn btn-secondary btn-sm" : "btn btn-sm"} disabled={Boolean(busy)}
                      onClick={() => act(u.id, "activate", { months: months[u.id] ?? 1 })}>{u.active ? "Продовжити" : "Активувати"}</button>
                  </>}
                  {u.activatedAt && u.id !== me.id && !u.adminByConfig && <button type="button" className="btn btn-ghost btn-sm" disabled={Boolean(busy)}
                    onClick={() => act(u.id, "deactivate", undefined, `Деактивувати ${u.email}? Доступ закриється до нової активації.`)}>Деактивувати</button>}
                  {u.id !== me.id && <button type="button" className="btn btn-ghost btn-sm" disabled={Boolean(busy)}
                    onClick={() => act(u.id, "disabled", { disabled: !u.disabled }, u.disabled ? null : `Заблокувати ${u.email}? Вхід стане неможливим, сесії завершаться.`)}>{u.disabled ? "Розблокувати" : "Заблокувати"}</button>}
                  {u.id !== me.id && !u.adminByConfig && <button type="button" className="btn btn-ghost btn-sm" disabled={Boolean(busy)}
                    onClick={() => act(u.id, "admin", { isAdmin: !u.isAdmin }, u.isAdmin ? `Зняти права адміністратора з ${u.email}?` : `Зробити ${u.email} адміністратором?`)}>{u.isAdmin ? "Зняти адміна" : "Зробити адміном"}</button>}
                </td>
              </tr>))}</tbody>
          </table>
        </div>)}
    </div>
  );
}

const TOKEN_STATE = { open: ["Діє", "badge-ok"], used: ["Використано", "badge-idle"], revoked: ["Відкликано", "badge-bad"], expired: ["Строк минув", "badge-warn"] };

function Tokens() {
  const [d, setD] = useState(null), [err, setErr] = useState(""), [v, setV] = useState(0);
  const [form, setForm] = useState({ forEmail: "", months: 1, expiresDays: 30, note: "" }), [made, setMade] = useState(null), [busy, setBusy] = useState(false), [copied, setCopied] = useState(false);
  useEffect(() => { api("/api/admin/tokens").then(setD, (e) => setErr(e.message)); }, [v]);
  const create = async (e) => {
    e.preventDefault(); setBusy(true); setErr(""); setCopied(false);
    try { setMade({ ...(await api("/api/admin/tokens", { method: "POST", body: { ...form, forEmail: form.forEmail.trim() || undefined, note: form.note.trim() || undefined } })), forEmail: form.forEmail.trim() }); setV((x) => x + 1); }
    catch (x) { setErr(x.message); } finally { setBusy(false); }
  };
  const revoke = async (id) => {
    if (!confirm("Відкликати токен? Ним більше не можна буде активувати акаунт.")) return;
    try { await api(`/api/admin/tokens/${id}`, { method: "DELETE" }); setV((x) => x + 1); } catch (x) { setErr(x.message); }
  };
  const copy = async () => { try { await navigator.clipboard.writeText(made.token); setCopied(true); } catch { setCopied(false); } };
  return (
    <>
      <form className="card admin-token-form" onSubmit={create}>
        <h2 className="h3">Новий токен</h2>
        <div className="account-row">
          <label className="field">Для адреси (необов'язково)<input type="email" value={form.forEmail} onChange={(e) => setForm({ ...form, forEmail: e.target.value })} placeholder="будь-хто з токеном" /></label>
          <label className="field">Строк доступу<select value={form.months} onChange={(e) => setForm({ ...form, months: Number(e.target.value) })}>
            {MONTHS.map(([m, l]) => <option key={m} value={m}>{l}</option>)}</select></label>
          <label className="field">Діє, днів<input type="number" min="0" max="365" value={form.expiresDays} onChange={(e) => setForm({ ...form, expiresDays: Number(e.target.value) })} />
            <span className="field-hint">0 — безстроково</span></label>
          <label className="field">Примітка<input value={form.note} maxLength={200} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="напр., оплата за рахунком № …" /></label>
          <button className="btn" disabled={busy}>{busy ? "Створюємо…" : "Створити токен"}</button>
        </div>
        {made && (
          <div className="admin-token-made" role="status">
            <code>{made.token}</code>
            <button type="button" className="btn btn-secondary btn-sm" onClick={copy}>{copied ? "Скопійовано" : "Копіювати"}</button>
            <p className="muted small">Передайте токен користувачу{made.forEmail ? ` ${made.forEmail}` : ""}: він вводить його на екрані «Активуйте акаунт». Токен показується лише зараз.</p>
          </div>
        )}
        {err && <p className="error small" role="alert">{err}</p>}
      </form>
      <div className="card">
        <h2 className="h3">Токени</h2>
        {!d ? <p className="muted" role="status">Завантаження…</p> : !d.tokens.length ? <p className="empty">Токенів ще немає.</p> : (
          <div className="table-wrap" tabIndex={0} role="region" aria-label="Токени активації">
            <table className="table-static">
              <thead><tr><th>Токен</th><th>Джерело</th><th>Для кого</th><th>Стан</th><th>Створено</th><th /></tr></thead>
              <tbody>{d.tokens.map((t) => {
                const [label, cls] = TOKEN_STATE[t.state];
                return (
                  <tr key={t.id}>
                    <td><code>{t.hint === "AUTO" ? "автоматично" : `…${t.hint}`}</code><br /><span className="muted small">{t.months === 12 ? "на рік" : "на місяць"}</span></td>
                    <td className="small">{t.source === "payment" ? "оплата карткою" : `адмін${t.createdBy ? ` · ${t.createdBy}` : ""}`}{t.note && <><br /><span className="muted">{t.note}</span></>}</td>
                    <td className="small">{t.forEmail || "будь-хто"}{t.usedBy && <><br /><span className="muted">використав: {t.usedBy}</span></>}</td>
                    <td><span className={`badge ${cls}`}>{label}</span>{t.state === "open" && t.expiresAt && <><br /><span className="muted small">до {day(t.expiresAt)}</span></>}</td>
                    <td className="small">{when(t.createdAt)}</td>
                    <td>{t.state === "open" && <button type="button" className="btn btn-ghost btn-sm" onClick={() => revoke(t.id)}>Відкликати</button>}</td>
                  </tr>);
              })}</tbody>
            </table>
          </div>)}
      </div>
    </>
  );
}
